<template>
  <div>
    <iframe :src="sourceHtml" align="left">
    </iframe>
  </div>
</template>

<script>
export default {
  name: 'Screenshot',
  props: {
    site: {
      type: String,
    },
  },
  data() {
    return {
      sourceHtml: `/pages/screenshots/${this.site}/index.html`,
    };
  },
};
</script>

<style scoped lang='stylus'>

body
  margin 0
  padding 0

iframe
  border 0
  position absolute
  left 0
  top 0
  width 100%
  height 100%

</style>
